import React from 'react';
import styles from "./styles";
import compose from "recompose/compose";
import { withStyles } from '@mui/styles';
import { withSnackbar } from "notistack";
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { orange } from '@mui/material/colors';
import MailProStar from '../UI/MailProStar';


const HomeValuationRatingStarsView = ({ classes, ratingValue }) => {
    const filledStars = [];
    const emptyStars = [];
    for (let i = 0; i < ratingValue; i++) {
        filledStars.push(<MailProStar key={`filled-${i}`} defaultFilled={true} starContainerStyle={{ width: '16px', height: '16px' }}  />);
    }
    for (let i = 0; i < 5 - ratingValue; i++) {
        emptyStars.push(<MailProStar key={`empty-${i}`} defaultFilled={false} starContainerStyle={{ width: '16px', height: '16px'  }} />);
    }
    return <div className={classes.homeValuationRatingStarsViewMain}>
        {filledStars}
        {emptyStars}
    </div>
}

export default compose(withStyles(styles), withSnackbar)(HomeValuationRatingStarsView);
